import React from 'react';
import cx from 'classnames';
import { filterDataProps } from '@THC/utils/helpers';
import styles from './VRM.module.scss';
export const VRM = ({ id, side, size, text, variant, ...rest }) => (<div className={cx(styles.vrm, styles[size], styles[side], styles[variant])} id={id} {...filterDataProps(rest)}>
		{text}
	</div>);
